import React, { useEffect, useState } from "react";
import { InvokePostServiceCall } from "../../api/apiServices";
import { useParams } from "react-router-dom";
import Header from "../../components/header/Header";
import { ToastContainer, toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import ChatHistory from "../../components/chat-history/ChatHistory";
import { marked } from "marked";
import MainContainer from "../../components/main-container/MainContainer";
import { Autocomplete, Button, TextField } from "@mui/material";
import { Markup } from "interweave";
import styled from "styled-components";
import { Language_Models } from "../../constants/AppConstant";
import { API } from "../../constants/APIConstant";

export const OldConvoContainer = styled.div`
  overflow-y: auto;
  width: -webkit-fill-available;
  width: -moz-available;
  height: 100%;
  flex: 1 1;
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ada89a;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
  }

  // ::-webkit-scrollbar {
  //   width: 12px;
  // }

  // ::-webkit-scrollbar-track {
  //   -webkit-box-shadow: inset 0 0 6px rgb(71, 207, 222);
  //   border-radius: 10px;
  // }

  // ::-webkit-scrollbar-thumb {
  //   border-radius: 10px;
  //   -webkit-box-shadow: inset 0 0 6px rgb(67, 214, 72);
  // }

  // scrollbar-width: thin;
  // scrollbar-color: #ada89a transparent;
`;

export const ConvoDiv = styled.div`
  border: 0.5px solid grey;
  padding: 10px;
  border-radius: 15px;
  margin: 2%;

  .copy-icon {
    float: right;
    cursor: pointer;
    display: none;
    opacity: 0.2;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }

  &:hover .copy-icon {
    display: block;
    opacity: 0.2;
  }
`;

function SummaryDetails() {
  const { id } = useParams();
  const [infoLoading, setInfoLoading] = useState(false);
  const [projectInfo, setProjectInfo] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [summaryRes, setSummaryRes] = useState("");
  const [languageModel, setLanguageModel] = useState({ title: "", value: "" });
  const [maxTokens, setMaxTokens] = useState({ title: "", value: "" });
  const notify = () => toast.error(`Something went wrong!`);

  // const [showSidebar, setShowSidebar] = useState(true);
  // const [showSpinner, setShowSpinner] = useState(false);
  // const [comparePid, setComparePid] = useState(null);
  // const [compareResult, setCompareResult] = useState(null);
  // const [projectName, setProjectName] = useState("");

  // const [compareResultAll, setCompareResultAll] = useState([]);

  // const getHistory = () => {
  //   let requestBody = {
  //     user_name: sessionStorage.getItem("userName"),
  //     project_name: id,
  //   };
  //   InvokePostServiceCall(`:5510/show_history`, requestBody)
  //     .then((response) => response.text())
  //     .then((result) => {
  //       let historyDetails = JSON.parse(result);
  //       let tempArr = [];

  //       console.log(historyDetails, "historyDetails");

  //       historyDetails.forEach((item) => {
  //         let projectAlreadyAdded = false;
  //         let projectIndex = "";

  //         let finalDataObject = {
  //           images: [],
  //           tables: null,
  //           result: item.summary,
  //           references: null,
  //         };
  //         for (let i = 0; i < tempArr.length; i++) {
  //           if (item.pdf_name === tempArr[i].pdf_name) {
  //             projectAlreadyAdded = true;
  //             projectIndex = i;
  //             break;
  //           }
  //         }
  //         if (projectAlreadyAdded) {
  //           tempArr[projectIndex].pid = item.pdf_name;
  //           tempArr[projectIndex].chatList.push({
  //             executed_at: item.created_at,
  //             question: item.pdf_name,
  //             response: finalDataObject,
  //           });
  //         } else {
  //           tempArr.push({
  //             chatList: [
  //               {
  //                 executed_at: item.created_at,
  //                 question: item.pdf_name,
  //                 response: finalDataObject,
  //               },
  //             ],
  //             pdfName: `${item.pdf1}, ${item.pdf2}`,
  //             name: item.pdf_name,
  //             pid: item.pdf_name,
  //             project_name: item.pdf_name,
  //           });
  //         }
  //         setCompareResultAll(tempArr);
  //       });
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // const setAllChatHistory = (newChat = null) => {
  //   let allChats = [];
  //   allChats = [...compareResultAll];

  //   if (newChat !== null) {
  //     allChats.push({
  //       pdfName: newChat.pdfName,
  //       name: newChat.project_name,
  //       pid: newChat.project_name,
  //       project_name: newChat.project_name,
  //       chatList: [
  //         {
  //           executed_at: newChat.created_at,
  //           question: newChat.project_name,
  //           response: newChat.chatList[0].response,
  //         },
  //       ],
  //     });
  //     setCompareResultAll(allChats);
  //   } else {
  //     setComparePid(null);
  //     setCompareResult(null);
  //   }
  // };

  // const setPreviousChat = (prevChat) => {
  //   let currChat = [];
  //   let currPid = null;
  //   let allChats = [];
  //   let index = -1;

  //   currChat = compareResult;
  //   currPid = comparePid;
  //   allChats = [...compareResultAll];

  //   if (currChat) {
  //     index = allChats.findIndex((chatlist) => {
  //       return chatlist.pid === currPid;
  //     });
  //   }

  //   if (index !== -1) {
  //     allChats[index].chatList[0].response.result = compareResult.response;
  //     allChats[index].reportList = [];
  //   }

  //   setCompareResultAll(allChats);

  //   setComparePid(prevChat.pid);
  //   setCompareResult({
  //     name: prevChat.pdfName,
  //     response: marked(prevChat.chatList[0]?.response?.result),
  //   });
  // };
  const handleInfo = () => {
    setInfoLoading(true);

    let requestBody = {
      project_name: id,
    };

    InvokePostServiceCall(API.summarizeDocuments_get_project_files, requestBody)
      .then((response) => response.json())
      .then((result) => {
        console.log(result, "result");
        let tempArr = [];
        result.pdf_list.forEach((item) => {
          let res = item.split("/")[item.split("/").length - 1];
          console.log(res);
          tempArr.push(res);
        });
        setProjectInfo(tempArr);
        setInfoLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setInfoLoading(false);
        notify();
      });
  };

  const handleCompare = async () => {
    try {
      setShowSpinner(true);

      const requestBody = {
        folder_name: id,
        pdf_name: selectedPdf,
        model_name: languageModel.value,
        max_tokens_to_sample: Number(maxTokens.value),
      };

      let response = await InvokePostServiceCall(
        API.summarizeDocuments_summarize_pdfs,
        requestBody
      );
      setShowSpinner(false);
      if (!response.ok || !response.body) {
        throw response.statusText;
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let tempData = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) {
          // setLoading(false);
          break;
        }
        let decodedChunk = decoder.decode(value, { stream: true });

        tempData += decodedChunk;

        setSummaryRes(tempData);
      }
    } catch (error) {
      console.log(error);
      setShowSpinner(false);
      notify();
    }
  };

  useEffect(() => {
    handleInfo();
  }, []);

  return (
    // <div className="main-chat-container">
    //   <Header
    //     showSidebar={showSidebar}
    //     setShowSidebar={setShowSidebar}
    //     // languageModel={languageModel}
    //     // setLanguageModel={setLanguageModel}
    //     showLanguageModels={false}
    //     isHistroyComp={true}
    //     showHomeButton={true}
    //   />
    //   {showSpinner && (
    //     <div className="custom-overlay">
    //       <Spinner animation="border" role="status">
    //         <span className="sr-only">Loading...</span>
    //       </Spinner>
    //     </div>
    //   )}
    //   <ToastContainer />
    //   <div className="chat-history-container">
    //     {showSidebar && (
    //       <div className="prev-chat">
    //         <ChatHistory
    //           setAllChatHistory={setAllChatHistory}
    //           setPreviousChat={setPreviousChat}
    //           setProjectName={setProjectName}
    //           isUseModel={true}
    //           allChat={compareResultAll}
    //           isDisbaled={false}
    //           pid={comparePid}
    //           isEVR={true}
    //           deleteChat={() => {}}
    //         ></ChatHistory>
    //       </div>
    //     )}
    //   </div>
    // </div>

    <MainContainer showHomeButton={true}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          margin: "10px 10px 0px 10px",
        }}
      >
        <ToastContainer />
        <Autocomplete
          value={languageModel}
          onChange={(event, newValue) => {
            setLanguageModel(newValue);
          }}
          options={Language_Models}
          getOptionLabel={(option) => option.title}
          sx={{ width: "300px" }}
          size="small"
          renderInput={(params) => (
            <TextField
              {...params}
              // label="Language Model *"
              placeholder="Language Model *"
            />
          )}
        />

        <Autocomplete
          value={maxTokens}
          onChange={(event, newValue) => {
            setMaxTokens(newValue);
          }}
          options={[
            { title: "Small", value: "200" },
            { title: "Medium", value: "500" },
            { title: "Large", value: "1000" },
          ]}
          getOptionLabel={(option) => option.title}
          sx={{ width: "300px", marginLeft: "10px" }}
          size="small"
          renderInput={(params) => (
            <TextField
              {...params}
              // label="Generated Output Length (Tokens) *"
              placeholder="Generated Output Length (Tokens) *"
            />
          )}
        />
        <Autocomplete
          disableClearable
          value={selectedPdf}
          onChange={(event, newValue) => {
            setSelectedPdf(newValue);
          }}
          size="small"
          options={projectInfo}
          // getOptionLabel={(option) => option.title}
          sx={{
            width: "300px",
            backgroundColor: "white",
            borderRadius: "5px !important",
            marginRight: "10px",
            marginLeft: "10px",
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              // variant="standard"
              sx={{
                backgroundColor: "white",
                borderRadius: "5px !important",
              }}
              // label="Language Model *"
              placeholder="Select PDF *"
            />
          )}
        />

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#004987",
            "&:hover": { backgroundColor: "#004987" },
          }}
          onClick={() => {
            setSummaryRes("");
            handleCompare();
          }}
          disabled={!selectedPdf || !maxTokens?.value || !languageModel?.value}
        >
          Get Summary{" "}
          {showSpinner && <Spinner size="sm" style={{ marginLeft: "5px" }} />}
        </Button>
      </div>
      <OldConvoContainer className="old-convo-container">
        {summaryRes && (
          <ConvoDiv
            // key={index}
            className={`old-chat ${"h-auto"}`}
          >
            <h4>Summary:</h4>
            <Markup content={marked(summaryRes)} />
          </ConvoDiv>
        )}
      </OldConvoContainer>
    </MainContainer>
  );
}

export default SummaryDetails;
